import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { FondsRebondService } from '../../Services';
import { FloatLabel } from '../../Components/FloatLabel';
import { FondsRebondSuccessWidget } from './FondsRebondSuccessWidget';

interface IFondsRebondFormWidgetProps {
    dictIdentificationCodeCuratorLabel: string;
    dictIdentificationCodeOutplacementLabel: string;
    dictDenominationCuratorLabel: string;
    dictDenominationOutplacementLabel: string;
    dictFilesLabel: string;
    dictNameCuratorLabel: string;
    dictNameOutplacementLabel: string;
    dictSurnameCuratorLabel: string;
    dictSurnameOutplacementLabel: string;
    dictNameWorkerLabel: string;
    dictSurnameWorkerLabel: string;
    dictErrorSubmit: string;
    dictSubmitLabel: string;
    dictUploadLabel: string;
    dictFailLabel: string;
    dictSuccessText: string;
    dictSuccessContact1: string;
    dictSuccessContact2: string;
    dictSuccessMail: string;
    dictSuccessPhone: string;
    dictSuccessSignature1: string;
    dictSuccessSignature2: string;
    dictGdprLabel: string;
    dictGdprLink: string;
    dictGdprUrl: string;
    dictFilesWorkersListLabel: string;
    dictFilesOtherLabel: string;
    dictFilesAttestationLabel: string;
    dictFilesAccordLabel: string;
    dictFilesPositiveProofLabel: string;
    dictFilesPlanLabel: string;
    dictRetryLabel: string;
    dictNoneLabel: string;
    dictErrorFileFormat: string;
    dictErrorFileSize: string;
    dictIdentificationCodeError: string;
    type: number;
    backFunc: () => void;
}

interface IFondsRebondFormWidgetState {
    identificationCode: string;
    denomination: string;
    files: File[];
    filesWorkerList: File[];
    filesPositiveProof: File[];
    filesAccord: File[];
    filesPlan: File[];
    filesAttestation: File[];
    filesOther: File[];
    name: string;
    nameWorker: string;
    surname: string;
    surnameWorker: string;
    type: number;
    submitError: boolean;
    isSuccess: number;
    isLoading: boolean;
    typeFile: string;
    isGdpr: boolean;
    fileError: string;
    lastKeyPressed: number;
}

export class FondsRebondFormWidget extends Component<
    IFondsRebondFormWidgetProps,
    IFondsRebondFormWidgetState
> {
    constructor(props: IFondsRebondFormWidgetProps) {
        super(props);
        this.state = {
            identificationCode: '',
            denomination: '',
            files: [],
            filesWorkerList: [],
            filesOther: [],
            filesPlan: [],
            filesPositiveProof: [],
            filesAttestation: [],
            filesAccord: [],
            name: '',
            nameWorker: '',
            surname: '',
            surnameWorker: '',
            type: this.props.type,
            submitError: false,
            isSuccess: 0,
            isLoading: false,
            typeFile: this.props.type === 1 ? 'WorkerList' : 'Accord',
            isGdpr: false,
            fileError: null as any,
            lastKeyPressed: null as any,
        };
    }

    handleHiddenButton = (event: React.MouseEvent<HTMLButtonElement>): void => {
        event.preventDefault();
        document.getElementById('fileButton')?.click();
    };

    handleChangeGdpr = (): void => {
        this.setState((prev) => ({ isGdpr: !prev.isGdpr }));
    };

    handleChangeDenomination = (
        event: React.ChangeEvent<HTMLInputElement>
    ): void => {
        this.setState({ denomination: event.currentTarget.value });
    };

    handleChangeName = (event: React.ChangeEvent<HTMLInputElement>): void => {
        this.setState({ name: event.currentTarget.value });
    };

    handleChangeNameWorker = (
        event: React.ChangeEvent<HTMLInputElement>
    ): void => {
        this.setState({ nameWorker: event.currentTarget.value });
    };

    handleChangeSurname = (
        event: React.ChangeEvent<HTMLInputElement>
    ): void => {
        this.setState({ surname: event.currentTarget.value });
    };

    handleChangeSurnameWorker = (
        event: React.ChangeEvent<HTMLInputElement>
    ): void => {
        this.setState({ surnameWorker: event.currentTarget.value });
    };

    handleChangeTypeFiles = (
        event: React.ChangeEvent<HTMLSelectElement>
    ): void => {
        this.setState({ typeFile: event.currentTarget.value });
    };

    handleChangeIdentificationCode = (
        event: React.ChangeEvent<HTMLInputElement>
    ): void => {
        let val = event.currentTarget.value.replace(/\D/g, '');

        // preventDefault on onChange is unnecessary (can be removed)

        const isCurator = this.isCurator();

        if (!isCurator) {
            if (val.length === 7) {
                val = val.substring(0, 6) + '-' + val.slice(-1);
            } else if (val.length === 10) {
                val =
                    val.substring(0, 6) +
                    '-' +
                    val.substring(6, 9) +
                    '.' +
                    val.slice(-1);
            } else if (val.length > 7 && val.length < 10) {
                val = val.substring(0, 6) + '-' + val.substring(6, 9);
            } else if (val.length > 10) {
                val =
                    val.substring(0, 6) +
                    '-' +
                    val.substring(6, 9) +
                    '.' +
                    val.substring(9, 11);
            }
        } else {
            if (val.length === 5) {
                val = val.substring(0, 4) + '.' + val.slice(-1);
            } else if (val.length === 8) {
                val =
                    val.substring(0, 4) +
                    '.' +
                    val.substring(4, 7) +
                    '.' +
                    val.slice(-1);
            } else if (val.length > 5 && val.length < 8) {
                val = val.substring(0, 4) + '.' + val.substring(4, 7);
            } else if (val.length > 8) {
                val =
                    val.substring(0, 4) +
                    '.' +
                    val.substring(4, 7) +
                    '.' +
                    val.substring(7, 10);
            }
        }

        this.setState({ identificationCode: val });
    };

    handleKeyDownIdentificationCode = (
        event: React.KeyboardEvent<HTMLInputElement>
    ): void => {
        // Allow Ctrl/Meta combos (copy/paste/select all)
        if (event.ctrlKey || event.metaKey) return;

        const allowedKeys = new Set([
            'Backspace',
            'Delete',
            'ArrowLeft',
            'ArrowRight',
            'ArrowUp',
            'ArrowDown',
            'Home',
            'End',
            'Tab',
        ]);

        if (/^\d$/.test(event.key) || allowedKeys.has(event.key)) {
            return;
        }

        event.preventDefault();
    };

    // If you still need it elsewhere:
    getFileExtension = (item: File): string | undefined => {
        return item.name.split('.').pop()?.toLowerCase();
    };

    handleChangeFiles = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const file = event.currentTarget.files?.[0];
        if (!file) return;

        const ext = this.getFileExtension(file);

        if (file.size > 5_000_000) {
            this.setState({ fileError: 'size' });
            return;
        }

        const allowed = new Set(['doc', 'docx', 'xls', 'xlsx', 'pdf']);
        if (!ext || !allowed.has(ext)) {
            this.setState({ fileError: 'format' });
            return;
        }

        this.setState({ fileError: null as any });

        const typeFile = this.state.typeFile;

        if (typeFile === 'WorkerList') {
            this.setState((prev) => ({
                filesWorkerList: [...prev.filesWorkerList, file],
            }));
        } else if (typeFile === 'Other') {
            this.setState((prev) => ({
                filesOther: [...prev.filesOther, file],
            }));
        } else if (typeFile === 'Accord') {
            this.setState((prev) => ({
                filesAccord: [...prev.filesAccord, file],
            }));
        } else if (typeFile === 'Attestation') {
            this.setState((prev) => ({
                filesAttestation: [...prev.filesAttestation, file],
            }));
        } else if (typeFile === 'Plan') {
            this.setState((prev) => ({ filesPlan: [...prev.filesPlan, file] }));
        } else if (typeFile === 'PositiveProof') {
            this.setState((prev) => ({
                filesPositiveProof: [...prev.filesPositiveProof, file],
            }));
        }
    };

    handleDelete = (item: File, type: string): void => {
        if (type === 'WorkerList') {
            this.setState((prev) => ({
                filesWorkerList: prev.filesWorkerList.filter((f) => f !== item),
            }));
            return;
        }

        if (type === 'Other') {
            this.setState((prev) => ({
                filesOther: prev.filesOther.filter((f) => f !== item),
            }));
            return;
        }

        if (type === 'Accord') {
            this.setState((prev) => ({
                filesAccord: prev.filesAccord.filter((f) => f !== item),
            }));
            return;
        }

        if (type === 'Plan') {
            this.setState((prev) => ({
                filesPlan: prev.filesPlan.filter((f) => f !== item),
            }));
            return;
        }

        if (type === 'PositiveProof') {
            this.setState((prev) => ({
                filesPositiveProof: prev.filesPositiveProof.filter(
                    (f) => f !== item
                ),
            }));
            return;
        }

        if (type === 'Attestation') {
            this.setState((prev) => ({
                filesAttestation: prev.filesAttestation.filter(
                    (f) => f !== item
                ),
            }));
        }
    };

    private onSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
        void this.handleSubmit(event);
    };

    private handleSubmit = async (
        event: React.FormEvent<HTMLFormElement>
    ): Promise<void> => {
        event.preventDefault();

        const captchaInput =
            event.currentTarget.querySelector<HTMLInputElement>(
                'input[type="hidden"][name="captchaToken"]'
            );
        const captchaToken = captchaInput?.value ?? '';

        if (!this.isSubmitEnabled()) {
            this.setState({ submitError: true });
            return;
        }

        this.setState({ isLoading: true });

        try {
            const result = await FondsRebondService.pushData(
                this.state,
                captchaToken
            );

            if (result === true) {
                this.setState({ isSuccess: 1 });
            } else {
                console.error(result);
                this.setState({ isSuccess: 2 });
            }
        } catch (err) {
            console.error(err);
            this.setState({ isSuccess: 2 });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    private isCurator(): boolean {
        return this.state.type === 1;
    }

    private isSubmitEnabled(): boolean {
        const isCurator = this.isCurator();

        return !!(
            this.state.identificationCode &&
            ((!isCurator && this.state.identificationCode.length === 13) ||
                (isCurator && this.state.identificationCode.length === 12)) &&
            this.state.denomination &&
            (this.state.filesWorkerList.length > 0 || !isCurator) &&
            (this.state.filesAccord.length > 0 ||
                this.state.filesPositiveProof.length > 0 ||
                this.state.filesAttestation.length > 0 ||
                this.state.filesPlan.length > 0 ||
                this.state.filesOther.length > 0 ||
                isCurator) &&
            this.state.name &&
            (this.state.nameWorker || isCurator) &&
            this.state.surname &&
            (this.state.surnameWorker || isCurator) &&
            this.state.type &&
            this.state.isGdpr
        );
    }

    floatLabelActive(selectedValue: string): boolean {
        return !!selectedValue;
    }

    retryFunc = (): void => {
        this.setState({
            isSuccess: 0,
            filesWorkerList: [],
            filesOther: [],
            filesPlan: [],
            filesAttestation: [],
            filesPositiveProof: [],
            filesAccord: [],
            files: [],
            isLoading: false,
        });
    };

    render() {
        if (this.state.isSuccess !== 0) {
            return (
                <FondsRebondSuccessWidget
                    isSuccess={this.state.isSuccess}
                    dictSuccessText={this.props.dictSuccessText}
                    dictSuccessContact1={this.props.dictSuccessContact1}
                    dictSuccessContact2={this.props.dictSuccessContact2}
                    dictSuccessMail={this.props.dictSuccessMail}
                    dictSuccessPhone={this.props.dictSuccessPhone}
                    dictSuccessSignature1={this.props.dictSuccessSignature1}
                    dictSuccessSignature2={this.props.dictSuccessSignature2}
                    dictFailLabel={this.props.dictFailLabel}
                    dictRetryLabel={this.props.dictRetryLabel}
                    retryFunc={this.retryFunc}
                ></FondsRebondSuccessWidget>
            );
        } else {
            const loading = {
                position: 'absolute',
                backgroundColor: '#D3D3D3',
                zIndex: 100,
                opacity: '25%',
                width: '95%',
            } as React.CSSProperties;
            const borderRadius = {
                borderRadius: '5px',
            } as React.CSSProperties;

            if (this.props.type === 2) {
                return (
                    <div>
                        {this.state.isLoading && (
                            <div
                                className="loading h-100"
                                style={loading}
                            ></div>
                        )}
                        <form className="container" onSubmit={this.onSubmit}>
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-12">
                                        <FloatLabel
                                            active={this.floatLabelActive(
                                                this.state.denomination
                                            )}
                                            label={
                                                this.props
                                                    .dictDenominationOutplacementLabel
                                            }
                                            labelId={'denomination'}
                                        >
                                            <input
                                                type="text"
                                                name="denomination"
                                                value={this.state.denomination}
                                                onChange={
                                                    this
                                                        .handleChangeDenomination
                                                }
                                            />
                                        </FloatLabel>
                                    </div>
                                    {this.state.submitError &&
                                        !this.state.denomination && (
                                            <div className="col-12">
                                                <label className="alert-danger">
                                                    {this.props.dictErrorSubmit}
                                                </label>
                                            </div>
                                        )}
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <FloatLabel
                                            active={this.floatLabelActive(
                                                this.state.name
                                            )}
                                            label={
                                                this.props
                                                    .dictNameOutplacementLabel
                                            }
                                            labelId={'name'}
                                        >
                                            <input
                                                type="text"
                                                name="name"
                                                value={this.state.name}
                                                onChange={this.handleChangeName}
                                            />
                                        </FloatLabel>
                                    </div>
                                    <div className="col-6">
                                        <FloatLabel
                                            active={this.floatLabelActive(
                                                this.state.surname
                                            )}
                                            label={
                                                this.props
                                                    .dictSurnameOutplacementLabel
                                            }
                                            labelId={'surname'}
                                        >
                                            <input
                                                type="text"
                                                name="surname"
                                                value={this.state.surname}
                                                onChange={
                                                    this.handleChangeSurname
                                                }
                                            />
                                        </FloatLabel>
                                    </div>
                                    {this.state.submitError &&
                                        !this.state.name && (
                                            <div className="col-6">
                                                <label className="alert-danger">
                                                    {this.props.dictErrorSubmit}
                                                </label>
                                            </div>
                                        )}
                                    {this.state.submitError &&
                                        !this.state.surname &&
                                        !this.state.name && (
                                            <div className="col-6">
                                                <label className="alert-danger">
                                                    {this.props.dictErrorSubmit}
                                                </label>
                                            </div>
                                        )}
                                    {this.state.submitError &&
                                        !this.state.surname &&
                                        this.state.name && (
                                            <div className="offset-6 col-6">
                                                <label className="alert-danger">
                                                    {this.props.dictErrorSubmit}
                                                </label>
                                            </div>
                                        )}
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <FloatLabel
                                            active={this.floatLabelActive(
                                                this.state.nameWorker
                                            )}
                                            label={
                                                this.props.dictNameWorkerLabel
                                            }
                                            labelId={'nameWorker'}
                                        >
                                            <input
                                                type="text"
                                                name="nameWorker"
                                                value={this.state.nameWorker}
                                                onChange={
                                                    this.handleChangeNameWorker
                                                }
                                            />
                                        </FloatLabel>
                                    </div>
                                    <div className="col-6">
                                        <FloatLabel
                                            active={this.floatLabelActive(
                                                this.state.surnameWorker
                                            )}
                                            label={
                                                this.props
                                                    .dictSurnameWorkerLabel
                                            }
                                            labelId={'surnameWorker'}
                                        >
                                            <input
                                                type="text"
                                                name="surnameWorker"
                                                value={this.state.surnameWorker}
                                                onChange={
                                                    this
                                                        .handleChangeSurnameWorker
                                                }
                                            />
                                        </FloatLabel>
                                    </div>
                                    {this.state.submitError &&
                                        !this.state.nameWorker && (
                                            <div className="col-6">
                                                <label className="alert-danger">
                                                    {this.props.dictErrorSubmit}
                                                </label>
                                            </div>
                                        )}
                                    {this.state.submitError &&
                                        !this.state.surnameWorker &&
                                        !this.state.nameWorker && (
                                            <div className="col-6">
                                                <label className="alert-danger">
                                                    {this.props.dictErrorSubmit}
                                                </label>
                                            </div>
                                        )}

                                    {this.state.submitError &&
                                        !this.state.surnameWorker &&
                                        this.state.nameWorker && (
                                            <div className="offset-6 col-6">
                                                <label className="alert-danger">
                                                    {this.props.dictErrorSubmit}
                                                </label>
                                            </div>
                                        )}
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <FloatLabel
                                            active={this.floatLabelActive(
                                                this.state.identificationCode
                                            )}
                                            label={
                                                this.props
                                                    .dictIdentificationCodeOutplacementLabel
                                            }
                                            labelId={'identificationCode'}
                                        >
                                            <input
                                                type="text"
                                                name="identificationCode"
                                                value={
                                                    this.state
                                                        .identificationCode
                                                }
                                                onChange={
                                                    this
                                                        .handleChangeIdentificationCode
                                                }
                                                onKeyDown={
                                                    this
                                                        .handleKeyDownIdentificationCode
                                                }
                                            />
                                        </FloatLabel>
                                    </div>
                                    {this.state.submitError &&
                                        !this.state.identificationCode && (
                                            <div className="col-12">
                                                <label className="alert-danger">
                                                    {this.props.dictErrorSubmit}
                                                </label>
                                            </div>
                                        )}
                                    {this.state.submitError &&
                                        this.state.identificationCode.length <
                                            13 && (
                                            <div className="col-12">
                                                <label className="alert-danger">
                                                    {
                                                        this.props
                                                            .dictIdentificationCodeError
                                                    }
                                                </label>
                                            </div>
                                        )}
                                </div>
                                <div className="row pt-5 mb-3">
                                    <div className="col-6 text-right">
                                        <label>
                                            {this.props.dictFilesLabel}
                                        </label>
                                    </div>
                                    <div className="col-6">
                                        <select
                                            id="typeFichier"
                                            name="typeFichier"
                                            className="mb-2"
                                            onChange={
                                                this.handleChangeTypeFiles
                                            }
                                            value={this.state.typeFile}
                                        >
                                            <option value="Accord">
                                                {
                                                    this.props
                                                        .dictFilesAccordLabel
                                                }
                                            </option>
                                            <option value="Plan">
                                                {this.props.dictFilesPlanLabel}
                                            </option>
                                            <option value="Attestation">
                                                {
                                                    this.props
                                                        .dictFilesAttestationLabel
                                                }
                                            </option>
                                            <option value="PositiveProof">
                                                {
                                                    this.props
                                                        .dictFilesPositiveProofLabel
                                                }
                                            </option>
                                            <option value="Other">
                                                {this.props.dictFilesOtherLabel}
                                            </option>
                                        </select>
                                        <input
                                            type="file"
                                            name="fichier"
                                            id="fileButton"
                                            onChange={this.handleChangeFiles}
                                            hidden
                                        />
                                        <button
                                            onClick={this.handleHiddenButton}
                                        >
                                            {this.props.dictUploadLabel}
                                        </button>
                                    </div>
                                    {this.state.fileError === 'size' && (
                                        <div className="col-12">
                                            <label className="alert-danger">
                                                {this.props.dictErrorFileSize}
                                            </label>
                                        </div>
                                    )}
                                    {this.state.fileError === 'format' && (
                                        <div className="col-12">
                                            <label className="alert-danger">
                                                {this.props.dictErrorFileFormat}
                                            </label>
                                        </div>
                                    )}
                                    {this.state.submitError &&
                                        this.state.filesAccord.length < 1 &&
                                        this.state.filesPlan.length < 1 &&
                                        this.state.filesAttestation.length <
                                            1 &&
                                        this.state.filesPositiveProof.length <
                                            1 &&
                                        this.state.filesOther.length < 1 && (
                                            <div className="col-12">
                                                <label className="alert-danger">
                                                    {this.props.dictErrorSubmit}
                                                </label>
                                            </div>
                                        )}
                                </div>
                                <div className="row px-4">
                                    <div
                                        className="col-12 border"
                                        style={borderRadius}
                                    >
                                        <div className="row">
                                            <div className="col-4 text-left border-right pt-4 pl-4">
                                                {
                                                    this.props
                                                        .dictFilesAccordLabel
                                                }
                                            </div>
                                            {this.state.filesAccord.length ===
                                                0 && (
                                                <div className="col-8 text-right pt-4 pl-4 alert-light">
                                                    {this.props.dictNoneLabel}
                                                </div>
                                            )}
                                            {this.state.filesAccord.length >
                                                0 && (
                                                <div className="col-8 pt-4 text-right pr-0">
                                                    {this.state.filesAccord.map(
                                                        (item) => (
                                                            <div
                                                                key={item.name}
                                                                className="row pr-0"
                                                            >
                                                                <div className="col-10">
                                                                    {item.name}
                                                                </div>
                                                                <div className="col-2 mt-n3">
                                                                    <button
                                                                        onClick={() =>
                                                                            this.handleDelete(
                                                                                item,
                                                                                'Accord'
                                                                            )
                                                                        }
                                                                        className="btn-no-look"
                                                                    >
                                                                        <i className="icon-cross"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className="row">
                                            <div className="col-4 text-left border-right pt-4 pl-4">
                                                {this.props.dictFilesPlanLabel}
                                            </div>
                                            {this.state.filesPlan.length ===
                                                0 && (
                                                <div className="col-8 text-right pt-4 pl-4 alert-light">
                                                    {this.props.dictNoneLabel}
                                                </div>
                                            )}
                                            {this.state.filesPlan.length >
                                                0 && (
                                                <div className="col-8 pt-4 text-right pr-0">
                                                    {this.state.filesPlan.map(
                                                        (item) => (
                                                            <div
                                                                key={item.name}
                                                                className="row pr-0"
                                                            >
                                                                <div className="col-10">
                                                                    {item.name}
                                                                </div>
                                                                <div className="col-2 mt-n3">
                                                                    <button
                                                                        onClick={() =>
                                                                            this.handleDelete(
                                                                                item,
                                                                                'Plan'
                                                                            )
                                                                        }
                                                                        className="btn-no-look"
                                                                    >
                                                                        <i className="icon-cross"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className="row">
                                            <div className="col-4 text-left border-right pt-4 pl-4">
                                                {
                                                    this.props
                                                        .dictFilesAttestationLabel
                                                }
                                            </div>
                                            {this.state.filesAttestation
                                                .length === 0 && (
                                                <div className="col-8 text-right pt-4 pl-4 alert-light">
                                                    {this.props.dictNoneLabel}
                                                </div>
                                            )}
                                            {this.state.filesAttestation
                                                .length > 0 && (
                                                <div className="col-8 pt-4 text-right pr-0">
                                                    {this.state.filesAttestation.map(
                                                        (item) => (
                                                            <div
                                                                key={item.name}
                                                                className="row pr-0"
                                                            >
                                                                <div className="col-10">
                                                                    {item.name}
                                                                </div>
                                                                <div className="col-2 mt-n3">
                                                                    <button
                                                                        onClick={() =>
                                                                            this.handleDelete(
                                                                                item,
                                                                                'Attestation'
                                                                            )
                                                                        }
                                                                        className="btn-no-look"
                                                                    >
                                                                        <i className="icon-cross"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className="row">
                                            <div className="col-4 text-left border-right pt-4 pl-4">
                                                {
                                                    this.props
                                                        .dictFilesPositiveProofLabel
                                                }
                                            </div>
                                            {this.state.filesPositiveProof
                                                .length === 0 && (
                                                <div className="col-8 text-right pt-4 pl-4 alert-light">
                                                    {this.props.dictNoneLabel}
                                                </div>
                                            )}
                                            {this.state.filesPositiveProof
                                                .length > 0 && (
                                                <div className="col-8 pt-4 text-right pr-0">
                                                    {this.state.filesPositiveProof.map(
                                                        (item) => (
                                                            <div
                                                                key={item.name}
                                                                className="row pr-0"
                                                            >
                                                                <div className="col-10">
                                                                    {item.name}
                                                                </div>
                                                                <div className="col-2 mt-n3">
                                                                    {' '}
                                                                    <button
                                                                        onClick={() =>
                                                                            this.handleDelete(
                                                                                item,
                                                                                'PositiveProof'
                                                                            )
                                                                        }
                                                                        className="btn-no-look"
                                                                    >
                                                                        <i className="icon-cross"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className="row">
                                            <div className="col-4 text-left border-right py-4 pl-4">
                                                {this.props.dictFilesOtherLabel}
                                            </div>
                                            {this.state.filesOther.length ===
                                                0 && (
                                                <div className="col-8 text-right py-4 pr-4 alert-light">
                                                    {this.props.dictNoneLabel}
                                                </div>
                                            )}
                                            {this.state.filesOther.length >
                                                0 && (
                                                <div className="col-8 pt-4 text-right pr-0">
                                                    {this.state.filesOther.map(
                                                        (item) => (
                                                            <div
                                                                key={item.name}
                                                                className="row pr-0"
                                                            >
                                                                <div className="col-10 pt-2">
                                                                    {item.name}
                                                                </div>
                                                                <div className="col-2 mt-n3">
                                                                    <button
                                                                        onClick={() =>
                                                                            this.handleDelete(
                                                                                item,
                                                                                'Other'
                                                                            )
                                                                        }
                                                                        className="btn-no-look"
                                                                    >
                                                                        <i className="icon-cross"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-4 px-4">
                                    <div
                                        className="col-12 text-left alert-warning pt-3"
                                        style={borderRadius}
                                    >
                                        <input
                                            type="checkbox"
                                            id="checkbox"
                                            onChange={this.handleChangeGdpr}
                                        />
                                        <label htmlFor="checkbox">
                                            {this.props.dictGdprLabel}{' '}
                                            <a
                                                href={this.props.dictGdprUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {this.props.dictGdprLink}
                                            </a>
                                        </label>
                                    </div>
                                    {this.state.submitError &&
                                        !this.state.isGdpr && (
                                            <div className="offset-2 col-8">
                                                <label className="alert-danger">
                                                    {this.props.dictErrorSubmit}
                                                </label>
                                            </div>
                                        )}
                                </div>
                            </div>
                            <div className="form-group submit mt-5">
                                <button type="submit" className="btn-block">
                                    <i className="icon-check"></i>
                                    {this.props.dictSubmitLabel}
                                </button>
                            </div>
                        </form>
                    </div>
                );
            }
            return (
                <form onSubmit={this.onSubmit}>
                    {this.state.isLoading && (
                        <div className="loading h-100" style={loading}></div>
                    )}
                    <div className="container">
                        <div className="form-group">
                            <div className="row">
                                <div className="col-12">
                                    <FloatLabel
                                        active={this.floatLabelActive(
                                            this.state.denomination
                                        )}
                                        label={
                                            this.props
                                                .dictDenominationCuratorLabel
                                        }
                                        labelId={'denomination'}
                                    >
                                        <input
                                            type="text"
                                            name="denomination"
                                            value={this.state.denomination}
                                            onChange={
                                                this.handleChangeDenomination
                                            }
                                        />
                                    </FloatLabel>
                                </div>
                                {this.state.submitError &&
                                    !this.state.denomination && (
                                        <div className="col-12">
                                            <label className="alert-danger">
                                                {this.props.dictErrorSubmit}
                                            </label>
                                        </div>
                                    )}
                            </div>
                            <div className="row">
                                <div className="col-6">
                                    <FloatLabel
                                        active={this.floatLabelActive(
                                            this.state.name
                                        )}
                                        label={this.props.dictNameCuratorLabel}
                                        labelId={'name'}
                                    >
                                        <input
                                            type="text"
                                            name="name"
                                            value={this.state.name}
                                            onChange={this.handleChangeName}
                                        />
                                    </FloatLabel>
                                </div>
                                <div className="col-6">
                                    <FloatLabel
                                        active={this.floatLabelActive(
                                            this.state.surname
                                        )}
                                        label={
                                            this.props.dictSurnameCuratorLabel
                                        }
                                        labelId={'surname'}
                                    >
                                        <input
                                            type="text"
                                            name="surname"
                                            value={this.state.surname}
                                            onChange={this.handleChangeSurname}
                                        />
                                    </FloatLabel>
                                </div>

                                {this.state.submitError && !this.state.name && (
                                    <div className="col-6">
                                        <label className="alert-danger">
                                            {this.props.dictErrorSubmit}
                                        </label>
                                    </div>
                                )}
                                {this.state.submitError &&
                                    !this.state.surname &&
                                    !this.state.name && (
                                        <div className="col-6">
                                            <label className="alert-danger">
                                                {this.props.dictErrorSubmit}
                                            </label>
                                        </div>
                                    )}
                                {this.state.submitError &&
                                    !this.state.surname &&
                                    this.state.name && (
                                        <div className="offset-6 col-6">
                                            <label className="alert-danger">
                                                {this.props.dictErrorSubmit}
                                            </label>
                                        </div>
                                    )}
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <FloatLabel
                                        active={this.floatLabelActive(
                                            this.state.identificationCode
                                        )}
                                        label={
                                            this.props
                                                .dictIdentificationCodeCuratorLabel
                                        }
                                        labelId={'identificationCode'}
                                    >
                                        <input
                                            type="text"
                                            name="identificationCode"
                                            value={
                                                this.state.identificationCode
                                            }
                                            onChange={
                                                this
                                                    .handleChangeIdentificationCode
                                            }
                                            onKeyDown={
                                                this
                                                    .handleKeyDownIdentificationCode
                                            }
                                        />
                                    </FloatLabel>
                                </div>
                                {this.state.submitError &&
                                    !this.state.identificationCode && (
                                        <div className="col-12">
                                            <label className="alert-danger">
                                                {this.props.dictErrorSubmit}
                                            </label>
                                        </div>
                                    )}
                                {this.state.submitError &&
                                    this.state.identificationCode.length <
                                        12 && (
                                        <div className="col-12">
                                            <label className="alert-danger">
                                                {
                                                    this.props
                                                        .dictIdentificationCodeError
                                                }
                                            </label>
                                        </div>
                                    )}
                            </div>

                            <div className="row pt-5 mb-3">
                                <div className="col-6 text-right">
                                    <label>{this.props.dictFilesLabel}</label>
                                </div>
                                <div className="col-6">
                                    <select
                                        id="typeFichier"
                                        name="typeFichier"
                                        className="mb-2"
                                        onChange={this.handleChangeTypeFiles}
                                        value={this.state.typeFile}
                                    >
                                        <option value="WorkerList">
                                            {
                                                this.props
                                                    .dictFilesWorkersListLabel
                                            }
                                        </option>
                                        <option value="Other">
                                            {this.props.dictFilesOtherLabel}
                                        </option>
                                    </select>
                                    <input
                                        type="file"
                                        name="fichier"
                                        id="fileButton"
                                        onChange={this.handleChangeFiles}
                                        hidden
                                    />
                                    <button onClick={this.handleHiddenButton}>
                                        {this.props.dictUploadLabel}
                                    </button>
                                </div>
                                {this.state.fileError === 'size' && (
                                    <div className="col-12">
                                        <label className="alert-danger">
                                            {this.props.dictErrorFileSize}
                                        </label>
                                    </div>
                                )}
                                {this.state.fileError === 'format' && (
                                    <div className="col-12">
                                        <label className="alert-danger">
                                            {this.props.dictErrorFileFormat}
                                        </label>
                                    </div>
                                )}
                                {this.state.submitError &&
                                    this.state.filesWorkerList.length < 1 && (
                                        <div className="col-12">
                                            <label className="alert-danger">
                                                {this.props.dictErrorSubmit}
                                            </label>
                                        </div>
                                    )}
                            </div>
                            <div className="row px-4">
                                <div
                                    className="col-12 border"
                                    style={borderRadius}
                                >
                                    <div className="row">
                                        <div className="col-4 text-left border-right pt-4 pl-4">
                                            {
                                                this.props
                                                    .dictFilesWorkersListLabel
                                            }
                                        </div>
                                        {this.state.filesWorkerList.length ===
                                            0 && (
                                            <div className="col-8 text-right pt-4 pl-4 alert-light">
                                                {this.props.dictNoneLabel}
                                            </div>
                                        )}
                                        {this.state.filesWorkerList.length >
                                            0 && (
                                            <div className="col-8 pt-4 text-right pr-0">
                                                {this.state.filesWorkerList.map(
                                                    (item) => (
                                                        <div
                                                            key={item.name}
                                                            className="row pr-0"
                                                        >
                                                            <div className="col-10">
                                                                {item.name}
                                                            </div>
                                                            <div className="col-2 mt-n3">
                                                                <button
                                                                    onClick={() =>
                                                                        this.handleDelete(
                                                                            item,
                                                                            'WorkerList'
                                                                        )
                                                                    }
                                                                    className="btn-no-look"
                                                                >
                                                                    <i className="icon-cross"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    <div className="row">
                                        <div className="col-4 text-left border-right py-4 pl-4">
                                            {this.props.dictFilesOtherLabel}
                                        </div>
                                        {this.state.filesOther.length === 0 && (
                                            <div className="col-8 text-right pt-4 pr-4 alert-light">
                                                {this.props.dictNoneLabel}
                                            </div>
                                        )}
                                        {this.state.filesOther.length > 0 && (
                                            <div className="col-8 pt-4 text-right pr-0">
                                                {this.state.filesOther.map(
                                                    (item) => (
                                                        <div
                                                            key={item.name}
                                                            className="row pr-0"
                                                        >
                                                            <div className="col-10">
                                                                {item.name}
                                                            </div>
                                                            <div className="col-2 mt-n3">
                                                                <button
                                                                    onClick={() =>
                                                                        this.handleDelete(
                                                                            item,
                                                                            'Other'
                                                                        )
                                                                    }
                                                                    className="btn-no-look"
                                                                >
                                                                    <i className="icon-cross"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-4 px-4">
                                <div
                                    className="col-12 text-left alert-warning pt-3"
                                    style={borderRadius}
                                >
                                    <input
                                        type="checkbox"
                                        id="checkbox"
                                        checked={this.state.isGdpr}
                                        onChange={this.handleChangeGdpr}
                                    />
                                    <label htmlFor="checkbox">
                                        {this.props.dictGdprLabel}{' '}
                                        <a
                                            href={this.props.dictGdprUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {this.props.dictGdprLink}
                                        </a>
                                    </label>
                                </div>
                                {this.state.submitError &&
                                    !this.state.isGdpr && (
                                        <div className="offset-2 col-8">
                                            <label className="alert-danger">
                                                {this.props.dictErrorSubmit}
                                            </label>
                                        </div>
                                    )}
                            </div>
                        </div>
                    </div>
                    <div className="form-group submit mt-5">
                        <button type="submit" className="btn-block">
                            <i className="icon-check"></i>
                            {this.props.dictSubmitLabel}
                        </button>
                    </div>
                </form>
            );
        }
    }
}

WidgetHelper.register(FondsRebondFormWidget, 'fonds-rebond-form-widget');
